export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["favicon.png"]),
	mimeTypes: {".png":"image/png"},
	_: {
		client: {"start":"_app/immutable/entry/start.CoTb5LEf.js","app":"_app/immutable/entry/app.DE5L62c3.js","imports":["_app/immutable/entry/start.CoTb5LEf.js","_app/immutable/chunks/entry.Ccbg-EBq.js","_app/immutable/chunks/scheduler.CgctGpYI.js","_app/immutable/entry/app.DE5L62c3.js","_app/immutable/chunks/scheduler.CgctGpYI.js","_app/immutable/chunks/index.Dzy1rpav.js"],"stylesheets":[],"fonts":[],"uses_env_dynamic_public":false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js'))
		],
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 2 },
				endpoint: null
			}
		],
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set([]);

export const base = "";